module.exports = __webpack_public_path__ + "img/340ff8d.png";